import Typography from '@mui/material/Typography';
import { Box, Tooltip } from '@mui/material';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import { TableColumn } from '../../../components/DataTable/TableColumn';
import { OrderProduct } from '../../../interfaces/Order/OrderProduct';
import { TextColumn } from '../../../components/DataTable/TextColumn';
import { DataTable } from '../../../components/DataTable/DataTable';
import { PriceColumn } from '../../../components/DataTable/PriceColumn';
import { sharedColors, sharedStyles } from '../../../utils/Style';

interface NameCellProps {
  orderProduct: OrderProduct;
}

const NameCell = (props: NameCellProps) => {
  const handleClick = () => {
    const url = `/products/catalog/${props.orderProduct.productID}`;
    window.open(url, '_blank');
  };

  return (
    <Tooltip
      title={
        <Typography>
          {`Barkod: ${props.orderProduct.barcode}`}
          <br />
          {`SKU: ${props.orderProduct.sku}`}
          {props.orderProduct.hepsiburadaSku && (
            <>
              <br />
              {`HB SKU: ${props.orderProduct.hepsiburadaSku}`}
            </>
          )}
          {props.orderProduct.discountedAtCheckout && (
            <>
              <br />
              <br /> Kasa önü indirimiyle alınan ürün
            </>
          )}
        </Typography>
      }
    >
      <Box
        onClick={handleClick}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 0.5,
          cursor: 'pointer',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.3,
          }}
        >
          <Typography sx={{ ...sharedStyles.body1 }}>
            {props.orderProduct.name.name}
          </Typography>

          {props.orderProduct.options.length > 0 && (
            <Typography
              sx={{ ...sharedStyles.body2, color: sharedColors.gray5 }}
            >
              {props.orderProduct.options
                .map((option) => option.optionValueName)
                .join(' / ')}
            </Typography>
          )}
        </Box>

        {props.orderProduct.discountedAtCheckout && (
          <OfflineBoltIcon color='primary' className='no-print' />
        )}
      </Box>
    </Tooltip>
  );
};

const columns: TableColumn<OrderProduct>[] = [
  {
    id: 'name',
    name: 'Ürün',
    accessor: (row) => <NameCell orderProduct={row} />,
  },
  {
    id: 'unit-price',
    name: 'Birim Fiyat',
    accessor: (row) => <PriceColumn value={row.companyPrice.raw} />,
  },
  {
    id: 'amount',
    name: 'Miktar',
    accessor: (row) => <TextColumn value={row.quantity.toString()} />,
  },
  {
    id: 'total',
    name: 'Toplam',
    accessor: (row) => <PriceColumn value={row.lineTotal.raw} />,
  },
];

interface OrderProductsTableProps {
  orderProducts: OrderProduct[];
}

export const OrderProductsTable = (props: OrderProductsTableProps) => {
  return (
    <DataTable
      columns={columns}
      totalCount={props.orderProducts.length}
      rows={props.orderProducts}
      hidePagination
    />
  );
};
